<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            class="personal-internships"
            :items="tableData"
            :fields="internshipFields">
            <template v-slot:options>
                <b-button
                    class="btn-add btn-add-internship"
                    v-b-modal="'create-personal-internship'"
                    variant="primary"
                    type="button">
                    {{ $t('internship.add_internship') }}
                </b-button>
            </template>

            <template v-slot:cell(action)="data">
                <div class="actions">
                    <b-button
                        class="btn-edit btn-edit-internship"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title="$t('common.edit')"
                        @click="editInternship(data.item.internship)">
                    </b-button>
                    <b-button
                        class="btn-sign-in btn-sign-in-internship"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title="$t('internship.register_for_this_project')"
                        @click="openSignUpModal(data.item.internship)">
                    </b-button>
                    <b-button
                        class="btn-remove btn-remove-internship"
                        v-b-tooltip.hover
                        variant="danger-icon-only"
                        :title="$t('common.delete')"
                        @click="removeInternship(data.item.id)">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>
        <design-2021-internships-student-personal-create-modal-component
            ref="create-personal-internship"
            @add-internship="addInternship($event)">
        </design-2021-internships-student-personal-create-modal-component>
        <design-2021-internships-student-personal-edit-modal-component
            ref="edit-personal-internship"
            @update-internship="updateInternship($event)">
        </design-2021-internships-student-personal-edit-modal-component>
        <design-2021-internship-student-motivation-modal-component
            @signUp="signUp($event)"
            :project-in="projectIn"
            ref="student-motivation-modal">
        </design-2021-internship-student-motivation-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-internships-student-personal-index-component',
    props: ['projectIn'],
    data() {
        return {
            internships: [],
            internshipFields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'location',
                    label: this.$t('common.location'),
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    computed: {
        tableData() {
            return this.internships.map((internship) => {
                return {
                    id: internship.id,
                    internship: internship,
                    name: internship.name,
                    // accepted: internship.accepted,
                    location: internship.location,
                };
            });
        },
    },
    methods: {
        signUp(project) {
            this.$emit('signUp', project);
        },
        openSignUpModal(internship) {
            this.$refs['student-motivation-modal'].show(internship, this.projectIn.id, false);
        },
        show() {
            this.axios.get(this.routes.studentPersonalInternshipsFetch()).then(
                (response) => {
                    this.internships = response.data;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        addInternship(internship) {
            this.internships.push(internship);
        },
        editInternship(internship) {
            this.$refs['edit-personal-internship'].show(internship);
        },
        updateInternship(internship) {
            this.internships = this.internships.map((internship2) => {
                if (internship2.id === internship.id) {
                    return internship;
                } else {
                    return internship2;
                }
            });
        },
        removeInternship(id) {
            this.alert
                .confirm(
                    this.$t('internship.delete_internship_place'),
                    this.$t('internship.are_you_sure_you_want_to_delete_this_internship_place'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }

                    this.axios.delete(this.routes.studentPersonalInternshipDelete(id)).then(
                        (response) => {
                            this.internships = this.internships.filter((item) => item.id !== id);
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },
    },
};
</script>

<style scoped></style>
